import React, { useEffect, useMemo, useState } from 'react'
import { getCategories } from '../../services/api/categories'
import { Address, ProductCategoryDetail } from '../../model'
import AddressForm from '../AddressForm/AddressForm'
import DynamicFaIcon from '../DynamicFaIcon/DynamicFaIcon'

interface OrderDetailSelectionProps {
    initialFormData?: Address
    handleFormChange(data: any, isValid: boolean): void
    onCategorySelect(cat: ProductCategoryDetail): void
    selectedOrderCategory: ProductCategoryDetail | undefined
}

const OrderDetailSelection: React.FunctionComponent<OrderDetailSelectionProps> = ({
    initialFormData,
    handleFormChange,
    onCategorySelect,
    selectedOrderCategory
}: OrderDetailSelectionProps) => {
    const [categories, setCategories] = useState([])
    const initial = useMemo(() => initialFormData, [initialFormData])

    //Mount
    useEffect(() => {
        const fetchCategories = async () => {
            try {
                const data = await getCategories()
                setCategories(data || [])
            } catch (e) {
                console.error(e)
            }
        }
        fetchCategories()
    }, [])

    return (
        <div className='w-full flex flex-col'>
            <div className='w-full flex space-x-3 lg:space-x-10 justify-between h-[215px] border-[--tb-blushPrimary] border py-4'>
                {categories.map((cat: any) => {
                    const isActive = Boolean(selectedOrderCategory?.id === cat.id)
                    return (
                        <div
                            key={`step-${cat.id}`}
                            onClick={() => onCategorySelect(cat)}
                            className={`
                relative flex hover:borderPrimaryColor border transition-colors cursor-pointer flex-1 bg-white items-center justify-center space-y-[5px] flex-col rounded-md p-3
                ${
                    isActive
                        ? 'borderPrimaryColor shadow-md border-opacity-100'
                        : 'borderFadedPrimaryColor shadow-sm border-opacity-50'
                }
              `}
                        >
                            <DynamicFaIcon className='text-[--tb-primary] text-3xl' iconName={cat.icon} />
                            <h2 className='text-lg mb-0'>{cat.name}</h2>
                            <p className='text-sm' dangerouslySetInnerHTML={{ __html: cat.description }}></p>
                            {isActive && (
                                <span className='bgPrimaryColor ccText flex items-center justify-center rounded-full w-8 h-8 absolute bottom-0 translate-y-1/2 border borderPrimaryColor'>
                                    <DynamicFaIcon iconName='check' className='text-lg' />
                                </span>
                            )}
                        </div>
                    )
                })}
            </div>
            {/* TODO Should be rendered conditionally based on selectedOrderCategory?.requestAddress */}
            {selectedOrderCategory && (
                <div className='w-full h-full flex shadow-sm flex-col mt-3 space-y-8 bg-white rounded-xl border-full p-6'>
                    <AddressForm onChange={handleFormChange} defaultValues={initial} />
                </div>
            )}
        </div>
    )
}

export default OrderDetailSelection
